/* eslint-disable no-useless-escape */
import React, { useState,useEffect } from 'react';
import VerifyOtp from './verifyOtp';
import '../../css/Login.css';
import useStateCallback from '../../helper/asyncSetState';
import ERPUtils from '../../helper/Utils';
import Loader from '../../helper/Loader';
import Popup from '../../helper/SuccessPopup';
import ApiGateway from '../../helper/ApiGateway';
import ResetPassword from './ResetPassword';
import Utils from '../../helper/Utils';
import { toast } from 'react-toastify';


const ForgotPassword = (props) => {
	const { loginback, close, openLogin } = props;

	// state:
	const [details, setDetails] = useState({
		Email: '',
		password: '',
		confirmPassword: '',
		otp: "",
		clientId:'',
		isRegistered: false
	});
	const [compState, setCompState] = useState({
		emailComp: true,
		otpComp: false,
		setPassComp: false
	});
	const [LoaderActive, setLoaderActive] = useState(false);
	const [ErrorMsg, setErrorMsg] = useState('');
	const [emailVerifyMsg, setEmailVerifyMsg] = useState(null);
	const [ErrorPopup, setErrorPopup] = useState(false);
	// const [ValidationError, setValidationError] = useStateCallback({
	// 	EmailError: false,
	// 	otpError: false
	// });
	// const [ValidationAlert, setValidationAlert] = useState(false);

	// required Fields:
	const [requiredFields, setRequiredFields] = useState({
		emailReqError: false,
		otpReqError: false,
		passwordReqError: false,
		confirmPasswordReqError: false
	});
	const [passwordError, setPasswordError] = useState(false);
	const [passErrorPopup, setPassErrorPopup] = useState(false);
	const [changeSuccess, setChangeSuccess] = useState(false);
	const [NewPasswordError, setNewPasswordError] = useState(false);

	// used Handlers

	// handlers:
	const onChangeHandler = (event) => {
		const oldData = { ...details };
		const name = event.target.name;
		const val = event?.target?.value;

		if (event.target.name === 'Email') {
			// eslint-disable-next-line
			// const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			// const validEmail = val === '' ? '' : val.match(EmailCheck);
			// if (validEmail !== null) {
			oldData[name] = val;
			// ValidationErrorHandler(name, false);
			// } else {
			// oldData[name] = val;
			// ValidationErrorHandler(name, true);
			// }
		}
		else if (name === 'otp') {
			if(val.length > 6){
				toast.error("Invalid OTP length or format");
			}else{
				oldData[name] = val;
			}
		} 
		else if (name === 'password') {
			oldData[name] = val;
			// passwordMeter(val);
			if (NewPasswordError) {
				setNewPasswordError(false);
			}
			oldData.confirmPassword = ""
		} else {
			oldData[name] = val;
		}
		if (ERPUtils.isNullorWhiteSpace(val) === false) {
			removeRequiredFields(name);
		}
		if (name === 'confirmPassword' && passwordError) {
			setPasswordError(false);
		}
		setDetails(oldData);
	};

	// const validateEmail = (val) => {
	// 	// eslint-disable-next-line
	// 	const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
	// 	const validEmail = val === '' ? '' : val.match(EmailCheck);
	// 	if (validEmail !== null) {
	// 		ValidationErrorHandler("Email", false);
	// 		if (!ERPUtils.isNullorWhiteSpace(validEmail)) {
	// 			// checkUserEmailOnBlur();
	// 		}
	// 	} else {
	// 		setEmailVerifyMsg(null)
	// 		ValidationErrorHandler("Email", true);
	// 	}
	// }

	const removeRequiredFields = (name) => {
		const oldData = { ...requiredFields };
		if (name === 'Email') {
			oldData['emailReqError'] = false;
		}
		if (name === 'otp') {
			oldData['otpReqError'] = false;
		}
		if (name === 'password') {
			oldData['passwordReqError'] = false;
		}
		if (name === 'confirmPassword') {
			oldData['confirmPasswordReqError'] = false;
		}
		setRequiredFields(oldData);
	};

	const StatusHandler = (name) => {
		var newobj = {};
		Object.keys(compState).map((el) => {
			if (el === name) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		const convert = { ...newobj };
		setCompState(convert);
	};

	// const ValidationErrorHandler = (name, removeError) => {
	// 	let target = name;
	// 	let comName = 'Error';
	// 	let stateName = target + comName;
	// 	if (removeError) {
	// 		setValidationError({
	// 			...ValidationError,
	// 			[stateName]: true
	// 		});
	// 	} else {
	// 		setValidationError({
	// 			...ValidationError,
	// 			[stateName]: false
	// 		});
	// 	}
	// };

	// const checkForValidationErrors = (target) => {
	// 	const CheckValidationErrorsData = { ...ValidationError };
	// 	let validationErrorsFound = [];
	// 	Object.keys(CheckValidationErrorsData).map((el) => {
	// 		validationErrorsFound.push(ValidationError[el]);
	// 		return '';
	// 	});
	// 	if (validationErrorsFound.indexOf(true) !== -1) {
	// 		// setValidationAlert(true);
	// 	} else {
	// 		CheckRequiredFields(target);
	// 	}
	// 	return '';
	// };

	const CheckRequiredFields = (target) => {
		const oldData = { ...requiredFields };
		if (ERPUtils.isNullorWhiteSpace(details.Email) && compState.emailComp) {
			oldData['emailReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.otp) && compState.otpComp) {
			oldData['otpReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.password) && compState.setPassComp) {
			oldData['passwordReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.confirmPassword) && compState.setPassComp) {
			oldData['confirmPasswordReqError'] = true;
		}
		checkForRequiredErrors(oldData, target);
	};

	const checkForRequiredErrors = (data, target) => {
		let validationErrorsFound = [];
		Object.keys(data).map((el) => {
			validationErrorsFound.push(data[el]);
			return '';
		});
		if (validationErrorsFound.indexOf(true) !== -1) {
			setRequiredFields(data);
		} else {
			setRequiredFields(data);
			if (target === 'email') {
				verifyEmailApi();
			}
			if (target === 'otp') {
				confirmOtp();
			}
			if (target === 'password') {
				checkpassword();
			}
		}
		return '';
	};

	const closeReqFieldAlert = (name) => {
		// if (name === 'validationAlert') {
		// 	setValidationAlert(false);
		// }
		if (name === 'password') {
			setPassErrorPopup(false);
		}
		if (name === 'changeSuccess') {
			setChangeSuccess(false);
			openLogin('login');
		}
		return '';
	};

	const AlertError = () => {
		setErrorPopup(true);
	};

	const ErrorPopupHandler = () => {
		setErrorPopup(!ErrorPopup);
	};

	const checkpassword = () => {
		const passwordCheck = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
		if (details.password.match(passwordCheck)) {
			setNewPasswordError(false);
			comparePasswords();
		} else {
			setNewPasswordError(true);
		}
	};

	const comparePasswords = () => {
		if (details.password === details.confirmPassword) {
			changePassword();
		} else {
			setPasswordError(true);
			setPassErrorPopup(true);
		}
	};

	// end

	// Api calls:
	const verifyEmailApi = () => {
		var data = {
			email: details.Email,
			clientId:details.clientId
		};
		if (ERPUtils.isNullorWhiteSpace(data.email)) {
			setErrorMsg('Please Enter a Valid Email address');
			AlertError();
		} else {
			setLoaderActive(true);
			ApiGateway.post('ApplicantSecurity/verifyApplicantEmail', data, (response) => {
				try {
					setLoaderActive(false);
					if (ERPUtils.isUndefinedOrNull(response.data) === false) {
						if (response.data.success === true) {
							StatusHandler('otpComp');
						} else {
							if (response.data.failureMessage !== null) {
								setErrorMsg(response.data.failureMessage);
								setEmailVerifyMsg(response.data.failureMessage)
							} else {
								setErrorMsg('An Error! occurred, Please try again');
								AlertError();
							}
						}
					} else {
						setErrorMsg('An Error! occurred, Please try again');
						AlertError();
					}
				} catch (ex) {
					setLoaderActive(false);
				} finally {
					setLoaderActive(false);
				}
			}, "Public");
		}
	};

	// const checkUserEmailOnBlur = () => {
	// 	var data = {
	// 		name: details.name,
	// 		email: details.Email,
	// 		password: details.password,
	// 		clientId:details.clientId
	// 	};
	// 	setLoaderActive(true);
	// 	ApiGateway.post('ApplicantSecurity/verifyRegisterApplicantEmail?isForRegister=' + false, data, (response) => {
	// 		try {
	// 			setLoaderActive(false);
	// 			if (ERPUtils.isUndefinedOrNull(response.data) === false) {
	// 				if (response.data.success === true) {
	// 					setEmailVerifyMsg(null);
	// 				} else {
	// 					if (response.data.failureMessage !== null) {
							
	// 						setEmailVerifyMsg(response.data.failureMessage);
	// 					} else {
	// 						setEmailVerifyMsg("An error occurred. Couldn't verify the email");
	// 					}
	// 				}
	// 			} else {
	// 				setEmailVerifyMsg("An error occurred. Couldn't verify the email");
	// 			}
	// 		} catch (ex) {
	// 			setLoaderActive(false);
	// 		} finally {
	// 			setLoaderActive(false);
	// 		}
	// 	}, "Public");
	// };

	const confirmOtp = () => {
		var data = {
			email: details.Email,
			otp: details.otp,
			clientId:details.clientId
		};
		if (ERPUtils.isNullorWhiteSpace(data.otp)) {
			setErrorMsg('Please Enter a valid Otp');
			// AlertError();
		} else {
			setLoaderActive(true);
			ApiGateway.post('ApplicantSecurity/verifyOtp', data, (response) => {
				try {
					setLoaderActive(false);
					if (ERPUtils.isUndefinedOrNull(response.data) === false) {
						if (response.data.success === true) {
							StatusHandler('setPassComp');
						} else {
							if (response.data.failureMessage !== null) {
								setErrorMsg(response.data.failureMessage);
								AlertError();
							} else {
								setErrorMsg('An Error! occurred, Please try again');
								AlertError();
							}
						}
					} else {
						setErrorMsg('An Error! occurred, Please try again');
						AlertError();
					}
				} catch (ex) {
					setLoaderActive(false);
				} finally {
					setLoaderActive(false);
				}
			}, "Public");
		}
	};

	const changePassword = () => {
		var data = {
			email: details.Email,
			password: details.password,
			clientId:details.clientId,
			otp:details.otp
		};
		if (ERPUtils.isNullorWhiteSpace(data.email)) {
			setErrorMsg('Please Enter a valid email');
			AlertError();
		} else if (ERPUtils.isNullorWhiteSpace(data.password)) {
			setErrorMsg('Please Enter a valid password');
			AlertError();
		} else {
			setLoaderActive(true);
			ApiGateway.post('ApplicantSecurity/changeApplicantPassword', data, (response) => {
				try {
					setLoaderActive(false);
					if (ERPUtils.isUndefinedOrNull(response.data) === false) {
						if (response.data.success === true) {
							setChangeSuccess(true);
						} else {
							if (response.data.failureMessage !== null) {
								setErrorMsg(response.data.failureMessage);
								AlertError();
							} else {
								setErrorMsg('An Error! occurred, Please try again');
								AlertError();
							}
						}
					} else {
						setErrorMsg('An Error! occurred, Please try again');
						AlertError();
					}
				} catch (ex) {
					setLoaderActive(false);
				} finally {
					setLoaderActive(false);
				}
			}, "Public");
		}
	};

	// password added methods and states

	const [violetRule, setVioletRule] = useState({
		isSmallAndCap: false,
		isNumOrSpecial: false,
		valideLength: false
	})
	const [passwordMatchError, setPasswordMatchError] = useState(false);

	const [disableConfirmPassword, setDisableConfirmPassword] = useState(true);

	const checkCaseOfString = (string) => {
		const
			upper = /[A-Z]/.test(string),
			lower = /[a-z]/.test(string);

		return upper && lower;
	}
	const checkCaseOfNum = (string) => {
		const
			number = /[0-9]/.test(string),
			specialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(string);

		return number && specialChar;
	}

	const validatePassword = (string) => {
		const isCapitalAndSmallRule = checkCaseOfString(string);
		const isValidNumOrSpecialCase = checkCaseOfNum(string);
		const validLength = string.length > 8;
		const ruleErrorsObj = { ...violetRule }

		if (isCapitalAndSmallRule && isValidNumOrSpecialCase && validLength) {
			setDisableConfirmPassword(false)
			ruleErrorsObj["isSmallAndCap"] = false
			ruleErrorsObj["isNumOrSpecial"] = false
			ruleErrorsObj["valideLength"] = false
		} else {
			setDisableConfirmPassword(true);
			if (!isCapitalAndSmallRule) ruleErrorsObj["isSmallAndCap"] = true;
			else ruleErrorsObj["isSmallAndCap"] = false;
			if (!isValidNumOrSpecialCase) ruleErrorsObj["isNumOrSpecial"] = true;
			else ruleErrorsObj["isNumOrSpecial"] = false;
			if (!validLength) ruleErrorsObj["valideLength"] = true;
			else ruleErrorsObj["valideLength"] = false;
		}

		setVioletRule(ruleErrorsObj);
	}

	const comparePaswordONBlur = () => {
		if (!ERPUtils.isNullorWhiteSpace(details.confirmPassword) && !ERPUtils.isNullOrEmpty(details.confirmPassword)) {
			if (details.password !== details.confirmPassword) {
				setPasswordMatchError(true);
			}
		} else {
			setPasswordMatchError(false);
		}
	}
	useEffect(() => {
		const getclientId = Utils.getUniqueID();
		sessionStorage.setItem("clientId", getclientId); 
		let client = {...details}
		client.clientId =getclientId
		setDetails(client)
	  },[]);

	return (
		
		<div>
			{compState.otpComp  ? (
				<VerifyOtp
					onChangeHandler={onChangeHandler}
					close={close}
					// ValidationError={ValidationError}
					// checkForValidationErrors={checkForValidationErrors}
					CheckRequiredFields={CheckRequiredFields}
					requiredFields={requiredFields}
					details={details}
				/>
			) : null}

			{compState.setPassComp ? (
				<ResetPassword
					requiredFields={requiredFields}
					// checkForValidationErrors={checkForValidationErrors}
					CheckRequiredFields={CheckRequiredFields}
					onChangeHandler={onChangeHandler}
					close={close}
					// ValidationError={ValidationError}
					details={details}
					passwordError={passwordError}
					NewPasswordError={NewPasswordError}
					validatePassword={validatePassword}
					checkCaseOfString={checkCaseOfString}
					comparePaswordONBlur={comparePaswordONBlur}
					checkCaseOfNum={checkCaseOfNum}
					violetRule={violetRule}
					disableConfirmPassword={disableConfirmPassword}
					passwordMatchError={passwordMatchError}

				/>
			) : null}

			{compState.emailComp ? (
				<div className="card employee-application-card-style-1">
					<div>
						<div className="ForgotFormHeader">
							<div><h3 className="headTypo">
								Forgot Password
							</h3></div>
							<div><button type="button" style={{fontSize:"40px"}} className="ForgotRemoveButton" onClick={close}>
									&times;
								</button>
								</div>
						</div>
						<div className="formBody">
							<div className="form-group has-feedback formWrapper">
								<p style={{ fontSize: '0.9rem', marginBottom: 25 }}>
									Please enter your registered email.
								</p>
							</div>
							<div className="form-group has-feedback formWrapper">
								<label className="formlabel">
									Email
								</label>
								<span className="loginsRequiredText">*</span>
								<input
									className="form-control input"
									onChange={onChangeHandler}
									name="Email"
									type="text"
									autoComplete="off"
									placeholder="Email Address"
									value={details.email}
									// onBlur={() => validateEmail(details.Email)}
									onKeyDown={(e)=>ERPUtils.isKeyBoardEnterPressed(e)?CheckRequiredFields('email'):""}
								/>
								<span toggle="#password-field" className="far fa-user field-icon" id="userIcon"></span>
								{emailVerifyMsg !== null ?
									<p className="ValidationError">
										
										<i className="fa fa-warning warningIcon" />{emailVerifyMsg}
									</p> : null
								}
								{requiredFields.emailReqError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />Please enter your email address
									</p>
								) : null}
								{/* {ValidationError.EmailError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />Please enter a valid email address
									</p>
								) : null} */}
							</div>
						</div>
						<div className="formFooter">
							<button className="ContinueButton" onClick={()=>CheckRequiredFields('email')}>
								Send OTP
							</button>
							<br />
							<span className="span">
								<p name="login" className="link link-primary emp-appl-custom-link"
									onClick={() => loginback("login")}
									tabIndex={0}
									onKeyDown={(e) => {
										if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
											loginback("login")
									}}>
									Login Here
								</p>
							</span>
						</div>
					</div>
				</div>
			) : null}

			{ErrorPopup ? (
				<Popup
					open={ErrorPopup}
					close={ErrorPopupHandler}
					msg={ErrorMsg}
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					title="Sorry!"
					success={false}
				/>
			) : null}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			{/* {ValidationAlert ? (
				<Popup
					open={ValidationAlert}
					close={closeReqFieldAlert}
					msg="You have few invalid error fields in the form"
					title="Sorry!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please review your form and submit"
					tabName="validationAlert"
				/>
			) : null} */}
			{passErrorPopup ? (
				<Popup
					open={passErrorPopup}
					close={closeReqFieldAlert}
					msg="Please make sure that your new password and confirm password matches."
					title="Error!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please review your form and submit"
					tabName="password"
				/>
			) : null}
			{changeSuccess ? (
				<Popup
					open={changeSuccess}
					close={closeReqFieldAlert}
					msg="Your password has been changed sucessfully, use your new password to log in"
					title="Success!"
					icon={<i className="fa fa-check successIcon" aria-hidden="true" />}
					success={true}
					tabName="changeSuccess"
				/>
			) : null}
		</div>
	);
};

export default ForgotPassword;
